// extracted by mini-css-extract-plugin
module.exports = {"indicator":"styles_indicator__qjz6Z","inlineIndicator":"styles_inlineIndicator__YwBwy","withLogo":"styles_withLogo__FWgZY"};